




import { Component, Mixins } from 'vue-property-decorator';
import OverviewMixin from '@/mixins/OverviewMixin';
import FieldDefs from './FieldDefs';
import { OverviewLayoutITF } from '@/interfaces';

@Component
export default class DeviceExportLayoutsOverview extends Mixins(OverviewMixin) {
  public tableCfg = FieldDefs;
  public fixedFilter: object = { report_layout_type: 1 };
}
